import { routeFrontOfficeAllEntityGroupementChainCommon } from '@/lib/routes/front_groupement/common/routeFrontOfficeAllEntityGroupementChainCommon'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Pages COMMUNES de l'espace groupement / chaine, portees par l'entite Group : ouvertes a
 * tout membre de l'espace (managers, delegues / consultants de zone, managers de zone) via
 * ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_USER. Les pages de gestion restent dans le
 * getter MANAGER (getFrontOfficeGroupGroupementChainListRoutesManager).
 */
const routeGroupementConsultation = [
  {
    // Fiche pharmacie de consultation (suivi) — hors menu (accessible depuis la liste pharmacies).
    route: 'GroupementPharmacyDetail',
    text: 'Fiche pharmacie',
    t: 'routes.frontoffice.groupement.pharmacyDetail',
    href: '/industryoffice/groupement-chain/pharmacy/[companyId]',
    menuHeader: false,
    position: 56,
  },
]

export const getFrontOfficeGroupGroupementChainListRoutesAllUser = [
  ...routeFrontOfficeAllEntityGroupementChainCommon,
  ...routeGroupementConsultation,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_USER],
}))

export default getFrontOfficeGroupGroupementChainListRoutesAllUser
